import { grey, red } from "@mui/material/colors";

const styles = {
  principalContainer: {
    minHeight: "100%",
    backgroundColor: grey[100],
    padding: "24px",
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  skeletonContainer: {
    padding: "0px !important",
    display: "flex",
    gap: "10px",
  },
  skeletonHistoryContainer: {
    padding: "0px !important",
    display: "flex",
    gap: "10px",
    justifyContent: 'center',
  },
  nonPadding: {
    padding: "0px !important",
  },
  searchField: {
    height: "38px",
    borderRadius: "0.5rem",
    flexGrow: 1,
  },
  addUserButton: {
    width: "130px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
  },
};

export default styles;
